
import { AplParameter } from "../types/aplParameter";
import { ReduxStateAuthAplParameter } from "../types/redux/reduxStateAuthAplParameter";
import { parseBool } from "./extensions";

const getParamByTypeNumber = (aplParameters: ReduxStateAuthAplParameter[], siteId: number, paramType: AplParameter): string => {
    let found = aplParameters.find(x => x.aplParameterType === paramType && x.confusingSiteId === siteId);
    if (found) {
        return found.value;
    }
    return aplParameters.find(x => x.aplParameterType === paramType && x.confusingSiteId === -1)?.value ?? "";
};

interface ConsumptionParams {
    inlineConsumption: boolean;
    consAllStatuses: boolean;
    maxIssuedPallets: number;
    maxIssuedPalletsConfirmConsume: number;
}

const getConsumptionParams = (aplParametersCollection: ReduxStateAuthAplParameter[], siteId: number): ConsumptionParams => {
    return {
        inlineConsumption: parseBool(getParamByTypeNumber(aplParametersCollection, siteId, AplParameter.InlineConsumption)),
        consAllStatuses: parseBool(getParamByTypeNumber(aplParametersCollection, siteId, AplParameter.ConsAllStatuses)),
        maxIssuedPallets: Number(getParamByTypeNumber(aplParametersCollection, siteId, AplParameter.MaxIssuedPallets)),
        maxIssuedPalletsConfirmConsume: Number(getParamByTypeNumber(aplParametersCollection, siteId, AplParameter.MaxIssuedPalletsConfirmConsume))
    };
};

export { getParamByTypeNumber, getConsumptionParams }
